import * as t from "io-ts";

export const EnquiryState = t.union([
  t.literal("viewed"),
  t.literal("contact_only"),
  t.literal("contact_agreed"),
  t.literal("ask_for_quote"),
  t.literal("quoted"),
  t.literal("preferences_set"),
  t.literal("submitted"),
  t.literal("converted_to_job"),
  t.literal("unreachable"),
  t.literal("not_interested"),
  t.literal("other_reason"),
]);

export type EnquiryState =
  | "viewed"
  | "contact_only"
  | "contact_agreed"
  | "ask_for_quote"
  | "quoted"
  | "preferences_set"
  | "submitted"
  | "converted_to_job"
  | "unreachable"
  | "not_interested"
  | "other_reason";
